// Date e ore mostrate sempre nel fuso del negozio (Europe/Rome),
// qualunque sia il fuso del browser.

const TZ = 'Europe/Rome';
const FMT_GIORNO_ISO = new Intl.DateTimeFormat('en-CA', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit' });
const FMT_DATA_ORA = new Intl.DateTimeFormat('it-IT', { timeZone: TZ, weekday: 'short', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
const FMT_DATA = new Intl.DateTimeFormat('it-IT', { timeZone: TZ, day: '2-digit', month: '2-digit', year: 'numeric' });
const FMT_QUANDO = new Intl.DateTimeFormat('it-IT', { timeZone: TZ, weekday: 'long', day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit' });
const FMT_ORA = new Intl.DateTimeFormat('it-IT', { timeZone: TZ, hour: '2-digit', minute: '2-digit' });
const FMT_GIORNO_ESTESO = new Intl.DateTimeFormat('it-IT', { timeZone: TZ, weekday: 'long', day: 'numeric', month: 'long' });

export const oggiRoma = (adesso: Date = new Date()): string => FMT_GIORNO_ISO.format(adesso);
export const giornoRoma = (iso: string): string => FMT_GIORNO_ISO.format(new Date(iso));

export function aggiungiGiorniIso(giorno: string, n: number): string {
  const [a, m, g] = giorno.split('-').map(Number);
  return new Date(Date.UTC(a, m - 1, g + n)).toISOString().slice(0, 10);
}

export const formatDataOraRoma = (iso: string): string => FMT_DATA_ORA.format(new Date(iso));
export const formatDataRoma = (iso: string | null): string => (iso ? FMT_DATA.format(new Date(iso)) : '—');
export const formatQuandoRoma = (iso: string): string => FMT_QUANDO.format(new Date(iso));
export const formatOraRoma = (iso: string): string => FMT_ORA.format(new Date(iso));
export const formatGiornoEsteso = (iso: string): string => FMT_GIORNO_ESTESO.format(new Date(iso));
